import { AddIcon } from '@chakra-ui/icons';
import { Button } from '@chakra-ui/react';

export default function AddItemButton({
    Icon = AddIcon,
    btnTitle = 'Tambah Produk',
    isDashedBtn = true,
    onClick = () => {},
    ...props
}) {
    return (
        <Button
            variant={'outline'}
            border={isDashedBtn ? '1px dashed' : '1px solid'}
            colorScheme="sagitarius"
            w={'full'}
            onClick={onClick}
            {...props}
        >
            <Icon fontSize={'sm'} /> {btnTitle}
        </Button>
    );
}
